import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  errors: [], // Array of error objects
};

const errorSlice = createSlice({
  name: 'errors',
  initialState,
  reducers: {
    // Add a new error
    addError: (state, action) => {
      const error = action.payload;
      state.errors.push(error);
    },
    // Remove a specific error by ID
    removeError: (state, action) => {
      state.errors = state.errors.filter((error) => error.id !== action.payload);
    },
    // Clear all errors
    clearErrors: (state) => {
      state.errors = [];
    },
  },
});

export const { addError, removeError, clearErrors } = errorSlice.actions;

export const selectErrors = (state) => state.errors.errors; // Select all errors

export const selectErrorsByType = (type) => (state) =>
  state.errors.errors.filter((error) => error.type === type);

export default errorSlice.reducer;
